import { IOperator } from '@entities/operator/@/tourProduct';
import TourProduct from '../model/TourProduct';

export default function (groupedTourProducts: TourProduct[][]): IOperator[][] {
    const operators = groupedTourProducts.map((tourProducts) => tourProducts.reduce((acc, tourProduct) => {
        if (tourProduct.operator) acc.push(tourProduct.operator);
        return acc;
    }, [] as IOperator[]));
    return operators;
}